export default "__VITE_ASSET__BvLHfe_c__"